var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mt-5" }, [
        _c("div", { staticClass: "col-lg-5" }, [
          _c("div", { staticClass: "form-group row pb-4" }, [
            _c(
              "label",
              { staticClass: "col-lg-3 pt-2", attrs: { for: "poli-select" } },
              [_vm._v("Poli")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-8" },
              [
                _c("select2", {
                  staticClass: "form-input",
                  attrs: { options: _vm.options_poli, id: "poli-select" },
                  on: { change: _vm.getJadwalDokter },
                  model: {
                    value: _vm.poli,
                    callback: function ($$v) {
                      _vm.poli = $$v
                    },
                    expression: "poli",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.show_data
        ? _c(
            "b-alert",
            {
              staticClass: "mt-3 text-center",
              attrs: { variant: "success", show: "" },
            },
            [
              _c("i", { staticClass: "fa fa-qrcode" }),
              _vm._v(" " + _vm._s(_vm.alert)),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "data-jadwal-dokter" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }